import { clientStorage } from "@/lib/clientStorage";
import { useEffect, useState } from "react";

export function usePersistentForm(storageKey, initialValue) {
  const [form, setForm] = useState(() => {
    try {
      const raw = clientStorage.getItem(storageKey);
      return raw ? { ...initialValue, ...JSON.parse(raw) } : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      clientStorage.setItem(storageKey, JSON.stringify(form));
    } catch {
      // ignore persistence failures
    }
  }, [storageKey, form]);

  const resetForm = () => {
    setForm(initialValue);
    try {
      clientStorage.removeItem(storageKey);
    } catch {
      // ignore persistence failures
    }
  };

  return { form, setForm, resetForm };
}
